import { CellTypes, PricingModelTab, PricingModelTableRow } from '../../..';
import { en } from '../../theme/languages/en';

export const getMinimumFeeRow = (product: PricingModelTab) => {
  let minimumFeeRow: PricingModelTableRow = {
    cells: {
      item: {
        cellId: 'item',
        cellType: CellTypes.ITEM_REFERENCE,
        cellValue: en.minimumFee,
        refObjectId: 'item',
        refObject: undefined,
      },
      price: {
        cellId: 'price',
        cellType: CellTypes.NUMBER,
        cellValue: product?.minimumFee,
        refObjectId: 'price',
        refObject: undefined,
      },
      amount: {
        cellId: 'amount',
        cellType: CellTypes.FORMULA,
        cellValue: product?.minimumFee,
        refObjectId: 'amount',
        refObject: undefined,
      },
      quantity: {
        cellId: 'quantity',
        cellType: CellTypes.COUNT,
        cellValue: 1,
        refObjectId: 'quantity',
        refObject: undefined,
      },
    },
    isHiddenInInvoice: false,
    isHidden: false,
    isSelectedForContract: false,
  };

  return [...product?.pricingModelTable?.rows, minimumFeeRow];
};
